import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DropdownReactiveFormModule} from '../../../../../../shared-components/dropdowns/dropdown-reactive-form/dropdown-reactive-form.module';
import {FormControlErrorMessagesModule} from '../../../../../../pipes/form-control-error-messages/form-control-error-messages.module';
import {FormControlModule} from '../../../../../../pipes/form-control/form-control.module';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {PostPutUserExperienceApiData} from '../../../../../../services/http-services/user-experience/user-experience-http-interfaces';
import {GrUserExperience} from '../../../../../../services/http-services/user-experience/user-experience-http-interfaces';
import {UserExperienceHttpService} from '../../../../../../services/http-services/user-experience/user-experience-http.service';
import {NgIf} from '@angular/common';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'gr-create-or-edit-user-experience-modal',
  templateUrl: './create-or-edit-user-experience-modal.component.html',
  standalone: true,
  imports: [
    DropdownReactiveFormModule,
    FormControlErrorMessagesModule,
    FormControlModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf
  ]
})

export class CreateOrEditUserExperienceModalComponent implements OnInit {
  createOrEditUserExperienceForm!: FormGroup;
  formTriedToSubmit = false;
  imageUrl = '';
  @Input() userExperienceForEdit: GrUserExperience | null = null;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmCreateExperience: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmEditExperience: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private userExperienceHttpService: UserExperienceHttpService) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.createOrEditUserExperienceForm = this.formBuilder.group({
      description: ['', Validators.required],
      image: ['', Validators.required],
      author: ['', Validators.required],
    });

    if (this.userExperienceForEdit) {
      this.createOrEditUserExperienceForm.patchValue(this.userExperienceForEdit);
      this.createOrEditUserExperienceForm.controls.image.patchValue('not changed');
      this.imageUrl = this.userExperienceForEdit?.image.full_path;
    }
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
      this.toastrService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
      return;
    } else if (file?.size > 10485760) {
      this.toastrService.warning(`Slika ${file.name} je veća od 10MB.`);
      return;
    } else {
      this.createOrEditUserExperienceForm.controls.image.patchValue(event.target.files[0]);
      this.imageUrl = URL.createObjectURL(file);
      this.fileInput.nativeElement.value = '';
    }
  }

  removeFile(): void {
    this.createOrEditUserExperienceForm.controls.image.patchValue(null);
    this.imageUrl = '';
  }

  submitUserExperienceForm(): void {
    this.formTriedToSubmit = true;
    if (this.createOrEditUserExperienceForm.valid) {
      const formData = new FormData();
      for (const key in this.createOrEditUserExperienceForm.value) {
        if (this.createOrEditUserExperienceForm.value[key] !== 'not changed') {
          formData.append(key, this.createOrEditUserExperienceForm.value[key]);
        }
      }
      this.userExperienceForEdit
        ? this.userExperienceHttpService.putUserExperience({experienceId: this.userExperienceForEdit.id}, formData).then((res: PostPutUserExperienceApiData) => {
          this.toastrService.success(res.message);
          this.confirmEditExperience.emit(res.data);
        })
        : this.userExperienceHttpService.postUserExperience(formData).then((res: PostPutUserExperienceApiData) => {
          this.confirmCreateExperience.emit(res.data);
          this.toastrService.success(res.message);
        });
    }
  }
}
